export default class summaryHelper {
  constructor(storageApi, instanceId) {
    this.storageApi = storageApi;
    this.ITEMS_SUMMARY_KEY = `${instanceId}_summary`;
    this.itemsSummary = null;
  }

  getItemsSummary() {
    if (this.itemsSummary) {
      return this.itemsSummary;
    } else {
      const itemSummaryFromStorage = this.getItemsSummaryFromStorage();
      if (itemSummaryFromStorage) {
        this.itemsSummary = itemSummaryFromStorage;
        return itemSummaryFromStorage;
      } else {
        // No items summary available - create empty items summary
        this.setItemsSummaryInStorage({});
        return this.getItemsSummary();
      }
    }
  }

  addItemToSummary(item) {
    const summary = this.getItemsSummary();
    const newSummary = { ...summary, [item.uuid]: item.quantity };
    return this.setItemsSummary(newSummary);
  }

  removeItemFromSummary(item) {
    const summary = this.getItemsSummary();
    const newSummary = { ...summary };
    delete newSummary[item.uuid];
    return this.setItemsSummary(newSummary);
  }

  updateCartItemInSummary(item) {
    const summary = this.getItemsSummary();
    const quantity = item.quantity;
    if (quantity && summary[item.uuid] !== quantity) {
      return this.setItemsSummary({ ...summary, [item.uuid]: item.quantity });
    }
    return summary;
  }

  setItemsSummary(summary) {
    this.setItemsSummaryInStorage(summary);
    this.itemsSummary = summary;
    return summary;
  }

  getItemsSummaryFromStorage() {
    const jsonSummary = this.storageApi.getItem(this.ITEMS_SUMMARY_KEY);
    return jsonSummary && JSON.parse(jsonSummary);
  }

  clearItemsSummaryInStorage() {
    this.storageApi.removeItem(this.ITEMS_SUMMARY_KEY);
    this.storageApi.clear(this.ITEMS_SUMMARY_KEY);
  }

  setItemsSummaryInStorage(summary) {
    this.storageApi.setItem(this.ITEMS_SUMMARY_KEY, JSON.stringify(summary));
  }

  clear() {
    this.clearItemsSummaryInStorage();
    this.itemsSummary = null;
  }
}
